import { render } from "./10.FAQs.vue?vue&type=template&id=ec8eb192&scoped=true"
import script from "./10.FAQs.vue?vue&type=script&lang=js"
export * from "./10.FAQs.vue?vue&type=script&lang=js"

import "./10.FAQs.vue?vue&type=style&index=0&id=ec8eb192&scoped=true&lang=css"
import "./10.FAQs.vue?vue&type=style&index=1&id=ec8eb192&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8eb192"]])

export default __exports__